import React from 'react'

function SelectedCyrcleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9" cy="9" r="9" fill="#4072C8"/>
<circle cx="9" cy="9" r="5" fill="white"/>
</svg>


    )
}

export default SelectedCyrcleIcon